(() => {
  const locale = window.SRThemeI18n?.locale === 'ur' ? 'ur-PK' : 'en-PK';
  const strings = window.SRThemeI18n?.custom || {};
  const translate = (key, fallback, replacements = {}) => {
    const configured = strings[key];
    let value = configured && !/translation missing:/i.test(String(configured)) ? configured : fallback;
    Object.entries(replacements).forEach(([token, replacement]) => {
      value = String(value).split(token).join(String(replacement));
    });
    return value;
  };
  const formatRupees = (value) => `Rs ${Math.round(Number(value || 0)).toLocaleString(locale, { numberingSystem: 'latn' })}`;
  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'PKR';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        numberingSystem: 'latn',
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return formatRupees(Number(cents || 0) / 100);
    }
  };

  const customOrderId = () => `SRM-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;

  const showMessage = (message) => {
    if (window.SRThemeCart?.showToast) {
      window.SRThemeCart.showToast(message);
      return;
    }
    const toast = document.querySelector('.sr-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    window.setTimeout(() => { toast.hidden = true; }, 3200);
  };

  const setButtonBusy = (button, busy, busyLabel) => {
    if (!button) return;
    const label = button.querySelector('span:last-child');
    if (!button.dataset.readyLabel && label) button.dataset.readyLabel = label.textContent.trim();
    button.disabled = busy;
    button.toggleAttribute('aria-busy', busy);
    if (label) label.textContent = busy ? busyLabel : button.dataset.readyLabel;
  };

  const appendSummaryRow = (container, title, detail) => {
    const row = document.createElement('div');
    const titleElement = document.createElement('strong');
    const detailElement = document.createElement('span');
    titleElement.textContent = title;
    detailElement.textContent = detail;
    row.append(titleElement, detailElement);
    container.append(row);
  };

  document.querySelectorAll('[data-custom-order-builder]').forEach((builder) => {
    if (builder.dataset.initialized === 'true') return;
    builder.dataset.initialized = 'true';

    const rootPath = builder.dataset.rootPath || window.Shopify?.routes?.root || '/';
    const minimumIngredients = Number(builder.dataset.minimumIngredients || 2);
    const minimumProducts = Number(builder.dataset.minimumProducts || 1);
    const targetMixWeight = Number(builder.dataset.targetMixWeight || 2.5);
    const targetMixGrams = Number(builder.dataset.targetMixGrams || 2500);
    const weightUnitGrams = Number(builder.dataset.weightUnitGrams || 5);
    const whatsappNumber = builder.dataset.whatsappNumber || '';

    const tabs = builder.querySelectorAll('[data-builder-tab]');
    const panels = builder.querySelectorAll('[data-builder-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const mode = tab.dataset.builderTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.builderPanel !== mode;
        });
      });
    });

    const ingredientRows = [...builder.querySelectorAll('[data-ingredient]')];
    const mixTotal = builder.querySelector('[data-mix-total]');
    const mixSelectedCount = builder.querySelector('[data-mix-selected-count]');
    const mixMeter = builder.querySelector('[data-mix-meter]');
    const mixMeterBar = builder.querySelector('[data-mix-meter-bar]');
    const mixStatus = builder.querySelector('[data-mix-status]');
    const mixSummaryList = builder.querySelector('[data-mix-summary-list]');
    const mixPerKg = builder.querySelector('[data-mix-per-kg]');
    const mixPrice = builder.querySelector('[data-mix-price]');
    const mixNotes = builder.querySelector('[data-mix-notes]');
    const mixButton = builder.querySelector('[data-add-custom-mix]');
    const customerDetails = builder.querySelector('[data-mix-customer-details]');
    const customerForm = builder.querySelector('[data-mix-customer-form]');
    const customerDetailsStatus = builder.querySelector('[data-customer-details-status]');
    const customerFields = customerForm ? [...customerForm.querySelectorAll('input[required], textarea[required]')] : [];
    let currentMix = null;

    const formatGrams = (grams) => `${Math.round(grams).toLocaleString(locale, { numberingSystem: 'latn' })} g`;
    const formatKg = (grams) => {
      const kilos = Number((Number(grams || 0) / 1000).toFixed(3));
      return `${kilos.toLocaleString(locale, { numberingSystem: 'latn', maximumFractionDigits: 3 })} ${translate('kg', 'KG')}`;
    };

    const allocateExactPouch = (selectedRows) => {
      if (!selectedRows.length) return [];
      const totalUnits = Math.round(targetMixGrams / weightUnitGrams);
      const baseUnits = Math.floor(totalUnits / selectedRows.length);
      const extraUnits = totalUnits % selectedRows.length;
      return selectedRows.map((row, index) => {
        const grams = (baseUnits + (index < extraUnits ? 1 : 0)) * weightUnitGrams;
        return {
          row,
          name: row.querySelector('[data-ingredient-name]')?.textContent.trim() || translate('ingredient', 'Ingredient'),
          grams,
          weight: grams / 1000,
          pricePerKg: Number(row.dataset.pricePerKg || 0)
        };
      });
    };

    const updateMix = () => {
      if (!mixTotal || !mixSummaryList) return;
      const selectedRows = ingredientRows.filter((row) => row.querySelector('[data-ingredient-toggle]')?.checked);
      const ingredients = allocateExactPouch(selectedRows);
      const selectedWeightGrams = ingredients.reduce((sum, item) => sum + item.grams, 0);
      const selectedWeight = selectedWeightGrams / 1000;
      const estimatedTotal = ingredients.reduce((sum, item) => sum + (item.pricePerKg * item.weight), 0);
      const ratePerKg = selectedWeight > 0 ? estimatedTotal / selectedWeight : 0;
      const mixComplete = selectedWeightGrams === targetMixGrams && ingredients.length >= minimumIngredients;
      const valid = mixComplete && Boolean(whatsappNumber);
      const customerComplete = customerFields.length > 0 && customerFields.every((field) => field.value.trim() && field.checkValidity());
      const orderReady = valid && customerComplete;

      mixTotal.textContent = selectedWeightGrams > 0
        ? `${formatKg(selectedWeightGrams)} / ${targetMixWeight} ${translate('kg', 'KG')}`
        : `0 / ${targetMixWeight} ${translate('kg', 'KG')}`;
      if (mixSelectedCount) mixSelectedCount.textContent = `${ingredients.length} / ${ingredientRows.length}`;
      mixMeterBar.style.width = `${Math.min(100, ingredients.length / minimumIngredients * 100)}%`;
      mixMeter.classList.remove('is-over');
      mixMeter.classList.toggle('is-complete', mixComplete);
      mixSummaryList.innerHTML = '';
      ingredients.forEach((item) => {
        const lineTotal = item.pricePerKg * item.weight;
        appendSummaryRow(mixSummaryList, item.name, `${formatGrams(item.grams)} × ${formatRupees(item.pricePerKg)}/${translate('kg', 'KG')} = ${formatRupees(lineTotal)}`);
      });

      if (mixPerKg) mixPerKg.textContent = formatRupees(ratePerKg);
      if (mixPrice) mixPrice.textContent = selectedWeight > 0 ? formatRupees(estimatedTotal) : '—';

      mixStatus.classList.toggle('is-valid', valid);
      if (ingredients.length < minimumIngredients) {
        mixStatus.textContent = translate('statusMinimum', `Choose at least ${minimumIngredients} different products for a custom mix.`, { '__count__': minimumIngredients });
      } else if (!whatsappNumber) {
        mixStatus.textContent = translate('statusWhatsappMissing', 'Add a WhatsApp number in Theme settings to accept custom mix orders.');
      } else {
        mixStatus.textContent = translate('statusReady', 'Selected ingredients were distributed automatically into one exact 2.5 KG pouch.');
      }

      if (customerDetails) {
        if (mixComplete && customerDetails.dataset.autoOpened !== 'true') {
          customerDetails.open = true;
          customerDetails.dataset.autoOpened = 'true';
        } else if (!mixComplete) {
          customerDetails.open = false;
          delete customerDetails.dataset.autoOpened;
        }
      }
      if (customerDetailsStatus) {
        customerDetailsStatus.classList.toggle('is-valid', orderReady);
        if (!mixComplete) {
          customerDetailsStatus.textContent = translate('detailsIncompleteMix', 'Complete your 2.5 KG mix to continue.');
        } else if (!customerComplete) {
          customerDetailsStatus.textContent = translate('detailsRequired', 'Mix complete — enter all required customer details to activate Place Order.');
        } else if (!whatsappNumber) {
          customerDetailsStatus.textContent = translate('detailsWhatsappMissing', 'Add the SR Traders WhatsApp number in Theme settings to place this order.');
        } else {
          customerDetailsStatus.textContent = translate('detailsReady', 'Details complete — your order is ready for WhatsApp.');
        }
      }
      if (mixButton) mixButton.disabled = !orderReady;
      ingredientRows.forEach((row) => {
        const ingredient = ingredients.find((item) => item.row === row);
        const state = row.querySelector('[data-ingredient-state]');
        const weight = row.querySelector('[data-ingredient-weight]');
        const cost = row.querySelector('[data-ingredient-cost]');
        row.classList.toggle('is-selected', Boolean(ingredient));
        if (state) state.textContent = ingredient ? translate('selected', 'Selected') : translate('tapToSelect', 'Tap to select');
        if (weight) weight.textContent = ingredient ? formatGrams(ingredient.grams) : '0 g';
        if (cost) cost.textContent = ingredient ? formatRupees(ingredient.pricePerKg * ingredient.weight) : formatRupees(0);
      });
      currentMix = { weight: selectedWeight, weightGrams: selectedWeightGrams, ingredients, ratePerKg, estimatedTotal, valid, orderReady };
    };

    ingredientRows.forEach((row) => {
      row.querySelector('[data-ingredient-toggle]')?.addEventListener('change', updateMix);
    });

    customerForm?.addEventListener('input', updateMix);
    customerForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      updateMix();
      if (!currentMix?.orderReady || !customerForm.reportValidity()) return;
      const reference = customOrderId();
      const composition = currentMix.ingredients
        .map((item) => `• ${item.name}: ${formatGrams(item.grams)} (${formatKg(item.grams)}) × ${formatRupees(item.pricePerKg)}/${translate('kg', 'KG')} = ${formatRupees(item.weight * item.pricePerKg)}`)
        .join('\n');
      const note = mixNotes?.value.trim();
      const customerName = customerForm.querySelector('[data-customer-name]')?.value.trim();
      const customerAddress = customerForm.querySelector('[data-customer-address]')?.value.trim();
      const customerPhone = customerForm.querySelector('[data-customer-phone]')?.value.trim();
      const customerWhatsapp = customerForm.querySelector('[data-customer-whatsapp]')?.value.trim();
      const message = [
        translate('whatsappIntro', 'Assalam-o-Alaikum, I would like to place an SR Traders custom atta mix order.'),
        '',
        `${translate('orderReference', 'Order Reference')}: ${reference}`,
        '',
        `${translate('customerDetails', 'Customer Details')}:`,
        `${translate('fullName', 'Full Name')}: ${customerName}`,
        `${translate('address', 'Complete Address')}: ${customerAddress}`,
        `${translate('phone', 'Active Phone')}: ${customerPhone}`,
        `${translate('whatsapp', 'Customer WhatsApp')}: ${customerWhatsapp}`,
        '',
        `${translate('orderDetails', 'Order Details')}:`,
        `${translate('packing', 'Packing')}: 1 ${translate('pouch', 'pouch')} × ${targetMixWeight} ${translate('kg', 'KG')}`,
        `${translate('selectedIngredients', 'Selected Ingredients')}: ${currentMix.ingredients.length}`,
        `${translate('allocationMethod', 'Weight Allocation')}: ${translate('automaticEqualShare', 'Automatic equal share, adjusted to exact grams')}`,
        `${translate('totalWeight', 'Total Weight')}: ${formatGrams(currentMix.weightGrams)} (${formatKg(currentMix.weightGrams)})`,
        `${translate('blendedRate', 'Blended Rate')}: ${formatRupees(currentMix.ratePerKg)} ${translate('perKg', 'per kg')}`,
        `${translate('estimatedTotal', 'Estimated Total')}: ${formatRupees(currentMix.estimatedTotal)}`,
        '',
        `${translate('mixComposition', 'Mix Composition')}:`,
        composition,
        note ? `\n${translate('specialInstructions', 'Special Instructions')}: ${note}` : '',
        '',
        translate('confirmNote', 'Please confirm availability, final price and delivery details.')
      ].filter(Boolean).join('\n');
      window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
      showMessage(translate('whatsappReady', 'Your complete custom mix order is ready in WhatsApp.'));
    });

    updateMix();

    const productCards = [...builder.querySelectorAll('[data-bundle-product]')];
    const boxCount = builder.querySelector('[data-box-count]');
    const boxStatus = builder.querySelector('[data-box-status]');
    const boxSummaryList = builder.querySelector('[data-box-summary-list]');
    const boxPrice = builder.querySelector('[data-box-price]');
    const boxButton = builder.querySelector('[data-add-product-box]');
    const prepareAsMix = builder.querySelector('[data-prepare-as-mix]');
    const boxNotes = builder.querySelector('[data-box-notes]');
    let selectedProducts = [];

    const getVariantData = (field) => {
      const source = field?.tagName === 'SELECT' ? field.selectedOptions[0] : field;
      return {
        id: Number(field?.value || 0),
        productTitle: source?.dataset.title || '',
        variantTitle: source?.dataset.variantTitle || '',
        price: Number(source?.dataset.price || 0),
        available: source?.dataset.available === 'true'
      };
    };

    const updateProductBox = () => {
      if (!boxSummaryList) return;
      selectedProducts = productCards.map((card) => {
        const toggle = card.querySelector('[data-bundle-toggle]');
        const variantField = card.querySelector('[data-bundle-variant]');
        const quantityInput = card.querySelector('[data-bundle-quantity]');
        const variant = getVariantData(variantField);
        const quantity = Math.max(1, Math.min(20, Number(quantityInput?.value || 1)));
        if (quantityInput) quantityInput.value = quantity;
        card.classList.toggle('is-selected', Boolean(toggle?.checked));
        return { card, toggle, variant, quantity };
      }).filter((item) => item.toggle?.checked && item.variant.available && item.variant.id);

      const total = selectedProducts.reduce((sum, item) => sum + item.variant.price * item.quantity, 0);
      boxCount.textContent = selectedProducts.length;
      boxPrice.textContent = formatMoney(total);
      boxSummaryList.innerHTML = '';
      selectedProducts.forEach((item) => {
        const variantDetail = item.variant.variantTitle && item.variant.variantTitle !== 'Default Title'
          ? `${item.variant.variantTitle} · ${translate('qtyDetail', `Qty ${item.quantity}`, { '__quantity__': item.quantity })}`
          : translate('qtyDetail', `Qty ${item.quantity}`, { '__quantity__': item.quantity });
        appendSummaryRow(boxSummaryList, item.variant.productTitle, variantDetail);
      });

      const valid = selectedProducts.length >= minimumProducts;
      boxStatus.classList.toggle('is-valid', valid);
      boxStatus.textContent = valid
        ? translate('boxReady', 'Your selected product order is ready to add to cart.')
        : translate('boxMinimum', `Select at least ${minimumProducts} product to continue.`, { '__count__': minimumProducts });
      boxButton.disabled = !valid;
    };

    productCards.forEach((card) => {
      const toggle = card.querySelector('[data-bundle-toggle]');
      const variantField = card.querySelector('[data-bundle-variant]');
      const quantity = card.querySelector('[data-bundle-quantity]');
      const cardPrice = card.querySelector('[data-bundle-card-price]');
      toggle?.addEventListener('change', updateProductBox);
      quantity?.addEventListener('input', updateProductBox);
      variantField?.addEventListener('change', () => {
        const variant = getVariantData(variantField);
        if (cardPrice) cardPrice.textContent = formatMoney(variant.price);
        updateProductBox();
      });
    });

    boxButton?.addEventListener('click', async () => {
      updateProductBox();
      if (selectedProducts.length < minimumProducts) return;
      const reference = customOrderId();
      const preparation = prepareAsMix?.checked
        ? translate('prepareMix', 'Mix selected flours into one blend')
        : translate('keepSeparate', 'Keep selected products separate');
      const instructions = boxNotes?.value.trim();
      const items = selectedProducts.map((item) => ({
        id: item.variant.id,
        quantity: item.quantity,
        properties: {
          [translate('propertyOrderType', 'Order Type')]: translate('propertyCustomSelection', 'Custom Product Selection'),
          [translate('propertyPreparation', 'Preparation')]: preparation,
          ...(instructions ? { [translate('propertyInstructions', 'Customer Instructions')]: instructions } : {}),
          '_Custom Order Reference': reference
        }
      }));

      setButtonBusy(boxButton, true, translate('adding', 'Adding custom order…'));
      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || translate('unableAdd', 'Unable to add this custom order.'));
        showMessage(translate('added', 'Your custom product order was added to cart.'));
        if (window.SRThemeCart?.open) {
          await window.SRThemeCart.open(boxButton);
        } else {
          document.querySelector('[data-cart-open]')?.click();
        }
      } catch (error) {
        showMessage(error.message || translate('addError', 'The custom order could not be added. Please try again.'));
      } finally {
        setButtonBusy(boxButton, false, '');
        updateProductBox();
      }
    });

    updateProductBox();
  });
})();
